import { dashboardConstants as dc } from 'srcReact/Dashboard/constants'

const initialState = {
  loading: false,
  data: null,
  header: null,
  id: 0,
  name: '',
  error: '',
  removeNewMember: {
    loading: false,
    success: false,
    error: ''
  },
  cancelInvitation: {
    loading: false,
    success: false,
    error: ''
  },
  renewInvitation: {
    loading: false,
    success: false,
    error: ''
  },
  mixrSuggestion: {
    loading: false,
    success: false,
    error: ''
  }
}

export function dashboardDetail(state = initialState, action) {
  const { response } = action

  switch (action.type) {
    case dc.GET_DASHBOARD_DATA_REQUEST:
      return {
        ...state,
        loading: true
      }
    case dc.GET_DASHBOARD_DATA_SUCCESS:
      return {
        ...state,
        data: action.response.dashboard_data,
        header: action.response.header,
        loading: false
      }
    case dc.GET_DASHBOARD_DATA_FAILURE:
      return {
        ...state,
        data: null,
        loading: false,
        error: action.error
      }
    case dc.ACCEPT_SUGGEST_MIXR_REQUEST:
    case dc.REJECT_SUGGEST_MIXR_REQUEST:
      return {
        ...state,
        mixrSuggestion: {
          loading: true,
          error: '',
          success: false
        }
      }
    case dc.ACCEPT_SUGGEST_MIXR_SUCCESS:
    case dc.REJECT_SUGGEST_MIXR_SUCCESS: {
      const { mixrId } = action
      const updatedMixrs = state.data.Pending_Actions?.Pending_mixr_suggestion.filter((u) => u.mixr_info.id != mixrId)
      return {
        ...state,
        mixrSuggestion: {
          loading: false,
          success: true,
          error: ''
        },
        data: {
          ...state.data,
          Pending_Actions: {
            ...state.data.Pending_Actions,
            Pending_mixr_suggestion: updatedMixrs
          }
        }
      }
    }
    case dc.ACCEPT_SUGGEST_MIXR_FAILURE:
    case dc.REJECT_SUGGEST_MIXR_FAILURE:
      return {
        ...state,
        mixrSuggestion: {
          loading: false,
          success: false,
          error: action.error
        }
      }
    case dc.REMOVE_NEW_MEMBER_REQUEST: {
      return {
        ...state,
        error: '',
        removeNewMember: {
          ...state.removeNewMember,
          loading: true,
          success: false,
          error: ''
        }
      }
    }

    case dc.REMOVE_NEW_MEMBER_SUCCESS: {
      const { userId, duration, from } = action
      const updatedMembers = state.data.Activity?.Members[duration]?.new_member.filter((u) => u.user_info.id != userId)
      return {
        ...state,
        removeNewMember: {
          ...state.removeNewMember,
          loading: false,
          success: true,
          error: ''
        },
        data: {
          ...state.data,
          Activity:
            from === 'activity'
              ? {
                  ...state.data.Activity,
                  Members: {
                    ...state.data.Activity.Members,
                    [duration]: {
                      ...state.data.Activity.Members[duration],
                      new_member: updatedMembers
                    }
                  }
                }
              : state.data.Activity,
          Interests:
            from === 'interest'
              ? {
                  ...state.data.Interests,
                  Workplace_member_shared_interest: state.data.Interests?.Workplace_member_shared_interest.filter(
                    (u) => u.user_info.id != userId
                  )
                }
              : state.data.Interests
        }
      }
    }

    case dc.REMOVE_NEW_MEMBER_FAILURE: {
      return {
        ...state,
        removeNewMember: {
          ...state.removeNewMember,
          loading: false,
          success: false,
          error: action.error
        }
      }
    }
    case dc.CANCEL_INVITATION_REQUEST: {
      return {
        ...state,
        error: '',
        cancelInvitation: {
          ...state.cancelInvitation,
          loading: true,
          success: false,
          error: ''
        }
      }
    }

    case dc.CANCEL_INVITATION_SUCCESS: {
      const { userId } = action
      const updatedInvites = state.data.Invitations?.Pending_invite.filter((u) => u.user_info.id != userId)
      return {
        ...state,
        cancelInvitation: {
          ...state.cancelInvitation,
          loading: false,
          success: true,
          error: ''
        },
        data: {
          ...state.data,
          Invitations: {
            ...state.data.Invitations,
            Pending_invite: updatedInvites
          }
        }
      }
    }

    case dc.CANCEL_INVITATION_FAILURE: {
      return {
        ...state,
        cancelInvitation: {
          ...state.cancelInvitation,
          loading: false,
          success: false,
          error: action.error
        }
      }
    }

    case dc.RENEW_INVITATION_REQUEST:
    case dc.RENEW_ALL_INVITATION_REQUEST: {
      return {
        ...state,
        error: '',
        renewInvitation: {
          ...state.renewInvitation,
          loading: true,
          success: false,
          error: ''
        }
      }
    }

    case dc.RENEW_INVITATION_SUCCESS:
    case dc.RENEW_ALL_INVITATION_SUCCESS: {
      const { userId } = action
      return {
        ...state,
        renewInvitation: {
          ...state.renewInvitation,
          loading: false,
          success: true,
          error: '',
          userId: userId
        }
      }
    }

    case dc.RENEW_INVITATION_FAILURE:
    case dc.RENEW_ALL_INVITATION_FAILURE: {
      return {
        ...state,
        renewInvitation: {
          ...state.renewInvitation,
          loading: false,
          success: false,
          error: action.error
        }
      }
    }
    case dc.CLEAR_DATA: {
      return initialState
    }
    default:
      return state
  }
}
